let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("affRy"), load("iY5MP")]).then(() => parcelRequire('3d2EW'));